var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoFix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7L19.05 4.95L17 4L19.05 3.05L20 1L20.95 3.05L23 4L20.95 4.95L20 7ZM8.5 7L7.55 4.95L5.5 4L7.55 3.05L8.5 1L9.45 3.05L11.5 4L9.45 4.95L8.5 7ZM20 18.5L19.05 16.45L17 15.5L19.05 14.55L20 12.5L20.95 14.55L23 15.5L20.95 16.45L20 18.5ZM5.1 21.7L2.3 18.9C2.1 18.7 2 18.4583 2 18.175C2 17.8917 2.1 17.65 2.3 17.45L13.45 6.3C13.65 6.1 13.8917 6 14.175 6C14.4583 6 14.7 6.1 14.9 6.3L17.7 9.1C17.9 9.3 18 9.54167 18 9.825C18 10.1083 17.9 10.35 17.7 10.55L6.55 21.7C6.35 21.9 6.10833 22 5.825 22C5.54167 22 5.3 21.9 5.1 21.7ZM5.85 19.6L13 12.4L11.6 11L4.4 18.15L5.85 19.6Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoFix);
export default __webpack_public_path__ + "static/media/auto-fix.db667907.svg";
export { ForwardRef as ReactComponent };